module.exports = __webpack_public_path__ + "img/SummaryBannerMobile.3bcd521d.svg";